module.exports = __webpack_public_path__ + "static/img/sample_mobile.c143316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/sample_mobile.png
// module id = Jh7M
// module chunks = 8